import axios from "../axios-auth";

export const departmentService = {
  getDepartmentList,
  saveDepartment,
  getDepartmentDetail,
  getDepartmentsByStatus,
};

function getDepartmentList(searchParams, page, size, sortedBy) {

  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/departments", { params });
}

function saveDepartment(department) {
  if (!department.id) {
    // new department
    return axios.post("/auth/department", department);
  } else {
    // edit
    return axios.put("/auth/department", department);
  }
}

function getDepartmentDetail(id) {
  return axios.get("/auth/department/" + id);
}

function getDepartmentsByStatus(status) {
  return axios.get("/auth/departments-by-status/" + status);
}

